/**
* control panel constants
* @author Faisal Siddiqui <hafizfaisalsiddiqui2@gmail.com>
* @comapany Voktro
*/
export class ThemeControlPanel {
}